import { FC } from "react";
import { Text, Flex } from "@mantine/core";
import { Data, UserData } from "../../../../types/org.type";
import { RegtankPassportPhoto } from "../hooks/useRegtankPhotos";
import { getDirectorUsers } from "../utils/getDirectorUsers";
import NationalIdentityCard, {
  LocalPassportPhoto,
} from "./NationalIdentityCard";

interface NationalIdentitySectionProps {
  data: Data | undefined;
  user: UserData[] | undefined;
  classes: Record<string, string>;
  isOrgRoute: boolean;
  hasBeenSentToWallex: boolean;
  screeningStatus: string | null;
  passportPhotoIsLoading: boolean;
  excludedFiles: string[];
  wallexPassportPhotos: Record<
    string,
    { ownerId: string; data: string; passportUserId?: string }
  >;
  regtankDocumentPhoto: RegtankPassportPhoto[];
  localPassportPhotos: Record<string, LocalPassportPhoto[]>;
  openIdentityPreview: (
    content: string,
    fileName: string,
    isPdf: boolean
  ) => void;
  toggleExcludePassportPhoto: (
    userId: string,
    frontPhoto: string,
    backPhoto: string,
    isLocal?: boolean
  ) => void;
  removeLocalPassportPhoto: (userId: string, fileIndex: number) => void;
  handlePassportPhotoUpload: (
    userId: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const NationalIdentitySection: FC<NationalIdentitySectionProps> = ({
  data,
  user,
  classes,
  isOrgRoute,
  hasBeenSentToWallex,
  screeningStatus,
  passportPhotoIsLoading,
  excludedFiles,
  wallexPassportPhotos,
  regtankDocumentPhoto,
  localPassportPhotos,
  openIdentityPreview,
  toggleExcludePassportPhoto,
  removeLocalPassportPhoto,
  handlePassportPhotoUpload,
}) => {
  const filteredUsers = getDirectorUsers(
    user,
    data?.boardOfDirectors,
    isOrgRoute
  );

  return (
    <>
      <Text className={classes.header}>National Identity Document</Text>

      {/* Org route with no Wallex photos */}
      {isOrgRoute &&
        hasBeenSentToWallex &&
        Object.keys(wallexPassportPhotos).length === 0 && (
          <div>
            <Text color="dimmed" italic align="center" py="md" size="lg">
              No National Identity Document has been sent.
            </Text>
          </div>
        )}

      <div className={classes.docContainer}>
        <Flex gap="md" wrap="wrap">
          {isOrgRoute && filteredUsers.length === 0 && !hasBeenSentToWallex ? (
            <div style={{ width: "100%", textAlign: "center" }}>
              <Text color="dimmed" italic align="center" py="md" size="lg">
                No National Identity Document available
              </Text>
            </div>
          ) : (
            filteredUsers.map((directorUser) => (
              <NationalIdentityCard
                key={directorUser.id}
                user={directorUser}
                classes={classes}
                hasBeenSentToWallex={hasBeenSentToWallex}
                screeningStatus={screeningStatus}
                passportPhotoIsLoading={passportPhotoIsLoading}
                excludedFiles={excludedFiles}
                wallexPassportPhotos={wallexPassportPhotos}
                regtankDocumentPhoto={regtankDocumentPhoto}
                localPassportPhotos={localPassportPhotos}
                openIdentityPreview={openIdentityPreview}
                toggleExcludePassportPhoto={toggleExcludePassportPhoto}
                removeLocalPassportPhoto={removeLocalPassportPhoto}
                handlePassportPhotoUpload={handlePassportPhotoUpload}
              />
            ))
          )}
        </Flex>
      </div>
    </>
  );
};

export default NationalIdentitySection;
